import type { PaginationMeta } from '../types/api';
import { formatNumber } from '../lib/format';

export function Pagination({
  meta,
  onPageChange,
  onLimitChange,
}: {
  meta: PaginationMeta;
  onPageChange: (page: number) => void;
  onLimitChange?: (limit: number) => void;
}) {
  const first = meta.total === 0 ? 0 : (meta.page - 1) * meta.limit + 1;
  const last = Math.min(meta.page * meta.limit, meta.total);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-rule px-3 py-2.5 text-xs text-ink-3">
      <span className="tabular">
        {formatNumber(first)}–{formatNumber(last)} of {formatNumber(meta.total)}
      </span>

      <div className="flex items-center gap-3">
        {onLimitChange && (
          <label className="flex items-center gap-1.5">
            <span>Rows</span>
            <select
              className="select h-7 w-auto py-0 text-xs"
              value={meta.limit}
              onChange={(e) => onLimitChange(Number(e.target.value))}
            >
              {[20, 50, 100].map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          </label>
        )}

        <div className="flex items-center gap-1">
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={() => onPageChange(meta.page - 1)}
            disabled={meta.page <= 1}
          >
            Previous
          </button>
          <span className="tabular px-2">
            {meta.page} / {Math.max(meta.totalPages, 1)}
          </span>
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={() => onPageChange(meta.page + 1)}
            disabled={!meta.hasNext}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
